// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"styles_searchWrapper__XPIfm","searchInput":"styles_searchInput__2e1NG","filters":"styles_filters__1-IOh","resetFiltersBtn":"styles_resetFiltersBtn__24v2w"};